//Menu configuration object containing keys, paths, and parent keys for navigation.
export const menuConfig: Record<string, { path?: string; menuParents: string[] }> = {
  'menu-item-parametres': { menuParents: [] },
  'menu-item-general': {
    path: '/cabinet/parametre-general',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-fiscal': {
    path: '/cabinet/parametre-comptabilite/fiscal',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-exercices': {
    path: '/cabinet/parametre-comptabilite',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-journaux': {
    path: '/cabinet/parametre-comptabilite/journaux',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-plan-comptable': {
    path: '/cabinet/parametre-comptabilite/plan-comptable',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-lettrage-auto': {
    path: '/cabinet/parametre-comptabilite/lettrage-auto',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-politique-immobilisation': {
    path: '/cabinet/parametre-comptabilite/politique-immobilisation',
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-analytique': {
    path: '/cabinet/parametre-comptabilite/analytique',
    menuParents: ['menu-item-parametres'],
  },

  'menu-item-social': {
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-juridique': {
    menuParents: ['menu-item-parametres'],
  },
  'menu-item-reglage-application': {
    menuParents: ['menu-item-parametres'],
  },

  'menu-item-pre-comptabilite': { menuParents: [] },
  'menu-item-precompta-transactions': {
    path: '/cabinet/precompta/finconnect/transactions',
    menuParents: ['menu-item-pre-comptabilite'],
  },
  'menu-item-precompta-banques': {
    path: '/cabinet/precompta/finconnect/banques',
    menuParents: ['menu-item-pre-comptabilite'],
  },

  'menu-item-points-en-suspens': {
    path: '/cabinet/dossier-point-suspens',
    menuParents: [],
  },

  'menu-item-production-comptable': { menuParents: [] },
  'menu-item-pieces': {
    path: '/cabinet/production-comptable/pieces',
    menuParents: ['menu-item-production-comptable'],
  },
  'menu-item-etats-comptables': {
    menuParents: ['menu-item-production-comptable'],
  },
  'menu-item-journal': {
    path: '/cabinet/production-comptable/journal',
    menuParents: ['menu-item-production-comptable', 'menu-item-etats-comptables'],
  },
  'menu-item-grand-livre': {
    path: '/cabinet/production-comptable/grand-livre',
    menuParents: ['menu-item-production-comptable', 'menu-item-etats-comptables'],
  },
  'menu-item-balance': {
    path: '/cabinet/production-comptable/balance',
    menuParents: ['menu-item-production-comptable', 'menu-item-etats-comptables'],
  },

  'menu-item-modules': {
    menuParents: ['menu-item-production-comptable'],
  },
  'menu-item-immobilisations': {
    menuParents: ['menu-item-production-comptable', 'menu-item-modules'],
    path: '/cabinet/immobilisations',
  },
  'menu-item-comptes-courants': {
    menuParents: ['menu-item-production-comptable', 'menu-item-modules'],
    path: '/cabinet/comptes-courants',
  },
  'menu-item-emprunt': {
    menuParents: ['menu-item-production-comptable', 'menu-item-modules'],
    path: '/cabinet/emprunts',
  },
  'menu-item-credits-bails': {
    menuParents: ['menu-item-production-comptable', 'menu-item-modules'],
  },
  'menu-item-cut-off': {
    menuParents: ['menu-item-production-comptable', 'menu-item-modules'],
  },
  'menu-item-cut-off-cca': {
    path: '/cabinet/cut-off/cca',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-pca': {
    path: '/cabinet/cut-off/pca',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-fnp': {
    path: '/cabinet/cut-off/fnp',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-aar': {
    path: '/cabinet/cut-off/aar',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-fae': {
    path: '/cabinet/cut-off/fae',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-aae': {
    path: '/cabinet/cut-off/aae',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-par': {
    path: '/cabinet/cut-off/par',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-cut-off-cap': {
    path: '/cabinet/cut-off/cap',
    menuParents: ['menu-item-production-comptable', 'menu-item-modules', 'menu-item-cut-off'],
  },
  'menu-item-revision-comptes': {
    menuParents: ['menu-item-production-comptable'],
  },
  'menu-item-etats-financiers': {
    menuParents: ['menu-item-production-comptable'],
  },

  'menu-item-plaquette': { menuParents: [] },
  'menu-item-teleportail': { menuParents: [] },
  'menu-item-facturation': { menuParents: [] },
};
